import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

/**
 * Clear two-path switcher so users and real estate agents always know which door is theirs.
 * mode: 'login' | 'register'
 * active: 'customer' | 'professional' (keys stay as API portal names)
 */
const AuthPortalSwitcher = ({ mode = 'login', active = 'customer' }) => {
  const isLogin = mode === 'login';
  const customerPath = isLogin ? '/login' : '/register';
  const proPath = isLogin ? '/pro/login' : '/pro/register';

  const options = [
    {
      key: 'customer',
      path: customerPath,
      icon: 'Home',
      title: 'Users',
      subtitle: 'Looking for property',
    },
    {
      key: 'professional',
      path: proPath,
      icon: 'Briefcase',
      title: 'Real Estate Agents',
      subtitle: 'Agents · Brokers · Advisors',
    },
  ];

  return (
    <div className="w-full mb-6">
      <p className="text-center text-xs font-medium text-muted-foreground uppercase tracking-wide mb-3">
        {isLogin ? 'Who is signing in?' : 'Who is joining?'}
      </p>
      <div className="grid grid-cols-2 gap-2 p-1 rounded-xl bg-muted/60 border border-border">
        {options.map((opt) => {
          const selected = active === opt.key;
          return (
            <Link
              key={opt.key}
              to={opt.path}
              className={`rounded-lg px-3 py-3 text-center transition-all ${
                selected
                  ? 'bg-background shadow-sm border border-primary/30 ring-1 ring-primary/20'
                  : 'hover:bg-background/70 border border-transparent'
              }`}
            >
              <div
                className={`mx-auto mb-1.5 w-9 h-9 rounded-full flex items-center justify-center ${
                  selected
                    ? opt.key === 'professional'
                      ? 'bg-secondary/15 text-secondary'
                      : 'bg-primary/15 text-primary'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                <Icon name={opt.icon} size={18} />
              </div>
              <p
                className={`text-sm font-semibold ${
                  selected ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {opt.title}
              </p>
              <p className="text-[11px] text-muted-foreground leading-tight mt-0.5">
                {opt.subtitle}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default AuthPortalSwitcher;
